import anamnese from './anamnese';
import onboarding from './onboarding';
import satisfacao from './satisfacao';

import consultoriaNutricionalInicial from './consultoria-nutricional-inicial';
import acompanhamentoNutricional from './acompanhamento-nutricional';
import reeducacaoAlimentar from './reeducacao-alimentar';

import avaliacaoFisicaPersonal from './avaliacao-fisica-personal';
import evolucaoSemanalTreino from './evolucao-semanal-treino';
import anamneseFitnessCompleta from './anamnese-fitness-completa';

import leadTreinoOnline from './lead-treino-online';
import leadCoachingFitness from './lead-coaching-fitness';
import leadDesafio30Dias from './lead-desafio-30-dias';

import leadNutricaoOnline from './lead-nutricao-online';
import leadEmagrecimento from './lead-emagrecimento';

import anamneseCorrida from './anamnese-corrida-iniciante';
import anamseCorridaAvancado from './anamnese-corrida-avancado';

import satisfacaoPosConsulta from './satisfacao-pos-consulta';
import npsProgramaTreino from './nps-programa-treino';

// Every template is a `(t) => ({...})` factory so its copy follows the active
// language; call this from a component with `useMemo(() => getTemplates(t), [t])`.
const getTemplates = (t) => [
    // Nutrição
    consultoriaNutricionalInicial(t),
    acompanhamentoNutricional(t),
    reeducacaoAlimentar(t),
    leadNutricaoOnline(t),
    leadEmagrecimento(t),
    satisfacaoPosConsulta(t),

    // Treino
    avaliacaoFisicaPersonal(t),
    evolucaoSemanalTreino(t),
    anamneseFitnessCompleta(t),
    leadTreinoOnline(t),
    leadCoachingFitness(t),
    leadDesafio30Dias(t),
    npsProgramaTreino(t),

    // Corrida
    anamneseCorrida(t),
    anamseCorridaAvancado(t),

    // Genéricos (legado)
    anamnese(t),
    onboarding(t),
    satisfacao(t),
];

export default getTemplates;
